"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.ToastNotification = void 0;
var react_1 = __importDefault(require("react"));
var uuid_1 = require("uuid");
var ToastNotificationManager_1 = require("./ToastNotificationManager");
/**
 * {@link https://cultureamp.design/components/toast-notification/ Guidance} |
 * {@link https://cultureamp.design/storybook/?path=/docs/components-notification-toast-notification--cautionary Storybook}
 */
var ToastNotification = function (_a) {
    var id = _a.id, _b = _a.hideCloseIcon, hideCloseIcon = _b === void 0 ? false : _b, _c = _a.autohide, autohide = _c === void 0 ? false : _c, _d = _a.autohideDelay, autohideDelay = _d === void 0 ? "long" : _d, otherProps = __rest(_a, ["id", "hideCloseIcon", "autohide", "autohideDelay"]);
    var localID = react_1["default"].useState(id || (0, uuid_1.v4)())[0];
    var persistent = autohide && hideCloseIcon;
    (0, ToastNotificationManager_1.addToastNotification)({
        id: localID,
        type: otherProps.type,
        title: otherProps.title,
        automationId: otherProps.automationId,
        autohide: autohide,
        autohideDelay: autohideDelay,
        message: otherProps.children,
        persistent: persistent,
        onHide: otherProps.onHide
    });
    return null;
};
exports.ToastNotification = ToastNotification;
exports.ToastNotification.displayName = "ToastNotification";
//# sourceMappingURL=ToastNotification.js.map